import { reaction } from 'mobx';
import { useEffect } from 'react';

import { refreshTokens } from '~/api/Requests';
import { mainStore } from '~/stores';

export const useTokenSync = () => {
  useEffect(() => {
    const syncOnReturn = () => {
      if (document.visibilityState === 'visible') {
        refreshTokens.sync('focus');
      }
    };

    const stopForegroundReaction = reaction(
      () => mainStore.inBackground,
      (inBackground) => {
        if (!inBackground) {
          refreshTokens.sync('focus');
        }
      },
    );

    window.addEventListener('focus', syncOnReturn);
    document.addEventListener('visibilitychange', syncOnReturn);

    return () => {
      stopForegroundReaction();
      window.removeEventListener('focus', syncOnReturn);
      document.removeEventListener('visibilitychange', syncOnReturn);
    };
  }, []);
};
